<script setup lang="ts">
import ToastLayer from '@/components/ToastLayer.vue'
// 껍데기는 라우터가 정합니다 — 로그인은 틀 밖에, 나머지는 AppShell 안에 뜹니다.
</script>

<template>
  <RouterView />
  <ToastLayer />
</template>
